import React, { ComponentProps } from 'react';
import { DefaultView, EditView, Views } from '../../types/BlockWithViews';
import { RoleSettingsEditView } from './views/RoleSettingsEditView';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { useAppContext } from '../../contexts/AppContext/AppContext';
import { RoleSettingsDefaultView } from './views/RoleSettingsDefaultView';

type RoleSettingsProps = Views<DefaultView<RoleSettingsDefaultView> & EditView<RoleSettingsEditView>>;

function RoleSettings(props: RoleSettingsProps) {
  const { active } = useAppContext().editModeInfo;
  return active
    ? <RoleSettingsEditView {...props.views.edit} />
    : <RoleSettingsDefaultView {...props.views.default} />;
}

export const RoleSettingsBlock = asBlock(RoleSettings, BlockType.rolesettings);
export type RoleSettingsBlock = ComponentProps<typeof RoleSettingsBlock>;
